export default "__VITE_ASSET__KR3O0ZMW__"